import * as React from "react";

const Diente45 = (props) => {

  //"#fff"
  let color= '#fff';
  //---------------
  //if(props.pza === props.pieza ){    //si es true, lo cambiamos de color el diente
    color= props.color;
  //}
  return (
  <svg style={{ width: "inherit", height: "inherit" }}
          version="1.1"
          viewBox="0 0 17.716535 28.346456"
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          {...props}
      >
   
   
   

     <g
      
      transform="translate(0,-1024.0158)"
    >
      <path
        fill= "#000"
        d="m 10.553558,1024.842 c -1.2204999,-0.2672 -3.6916799,-0.2255 -4.9730799,0.2623 -1.21024,0.4955 -2.06782,1.5 -2.37075,2.777 -0.30293,1.2771 -0.20972,2.5888 -0.96488,5.1848 -1.10949,4.7464 -1.08248,8.8956 -0.25701,11.7467 1.28298,2.6399 5.24049,6.9573 6.52613,6.963 3.0238499,-0.3646 5.6392999,-3.8958 7.7344299,-6.3965 1.50116,-2.6679 1.65293,-6.1387 0.87986,-10.0015 -0.24574,-1.9213 -1.06198,-4.0266 -2.20563,-5.9528 -0.79008,-1.6029 -2.20746,-4.1096 -4.36907,-4.583 z m 0.16052,0.9837 c 2.06526,1.4265 2.50513,2.5473 3.46949,4.23 1.55399,2.7934 1.36269,3.1066 2.15251,5.4099 0.31085,5.1483 0.43084,6.7318 -0.49763,8.6284 -1.72261,2.6445 -4.96559,6.5062 -7.1685299,6.8454 -1.1074,-0.1488 -4.78708,-4.4491 -5.96009,-7.066 -0.65247,-3.0914 -0.38624,-7.5428 0.41415,-10.519 0.42903,-1.3271 0.60433,-3.9634 1.03998,-5.362 0.40325,-1.2947 0.88897,-1.6449 1.88289,-2.203 1.67267,-0.4218 3.05381,-0.2285 4.6672299,0.036 z m -1.5152899,3.9627 c -0.5422,-0.2385 -2.56856,-0.9121 -3.09871,-0.4462 0.11541,1.673 1.65802,0.215 2.51976,1.4322 0.3855,3.1502 0.36628,4.9711 0.92341,6.6611 0.9835599,2.7161 1.2938899,2.3683 2.2040199,5.7092 0.0749,0.414 -3.2571999,2.4384 -2.4089499,2.9967 0.7644199,0.5031 2.6551399,-1.9023 3.0950799,-2.1872 0.30212,-0.2919 0.41168,-0.4017 0.36193,-0.8628 -0.35417,-1.3155 -2.03016,-4.6227 -2.38851,-5.8548 -0.5209999,-2.6016 -0.7277099,-6.6304 -0.7277099,-6.6304 0,0 -0.11976,-0.5672 -0.48032,-0.8178 z"        
      />
      <path
      fill={color}
      stroke="#000"
      strokeWidth={0.012}
      d="m 7.5583467,1025.5554 c -2.5353564,-0.3512 -3.6689411,2.3473 -3.8935446,4.3849 -0.8915027,4.6096 -2.0438496,9.4821 -0.9596508,14.1428 1.4491038,2.6023 3.2660188,5.269 5.8000504,6.9141 2.8382853,-0.7341 4.7292333,-3.3612 6.4734693,-5.5269 2.636553,-3.2268 1.71231,-7.6813 1.012354,-11.4104 -1.100927,-3.0641 -2.49781,-6.5423 -5.440772,-8.2955 -0.9565394,-0.3152 -2.0028643,-0.1783 -2.9919063,-0.209 z m -0.932868,3.609 c 1.4026961,-0.089 3.3418895,0.4124 3.239277,2.1508 -0.1921828,4.1411 1.5036043,7.9696 2.9327753,11.7523 -0.347818,1.5039 -1.970156,2.6202 -3.2513649,3.368 -0.7408598,-0.3394 0.4459926,-1.3518 0.7014039,-1.6921 1.732696,-1.0627 1.233877,-3.1882 0.395479,-4.6437 -1.6910125,-2.8494 -1.3908053,-6.2657 -2.4049254,-9.3036 -0.2606184,-1.182 -2.2845452,-0.1915 -2.1646081,-1.4327 0.089962,-0.2034 0.3630051,-0.1909 0.5519632,-0.199 z"
    />
    </g>



    
    
  
  </svg>
)}
export default Diente45;